import { coreDefaultTheme } from '@kite-js/theme';
import colors from './colors';
import palette from './palette';
import font from './font';
import typography from './typography';
import input from './input';
import select from './select';
import text from './text';
import label from './label';
import dottedProgress from './dottedProgress';

const coreWikibuyTheme = {
    ...coreDefaultTheme,
    font,
    typography,
    colors,
    palette,
    input,
    select,
    text,
    label,
    dottedProgress,
};

export { colors, coreWikibuyTheme };
